import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { createFiscalYear } from '../../service/fiscalYearService'
import { contextCompanyIdSelector } from '../../../../redux/context/company/selectors'
import fiscalYearQueryKeys from '../fiscalYearQueryKeys'
import { FiscalYear } from '../../../../types/fiscalYear/FiscalYear'

export const useCtxCreateFiscalYear = () => {
  const { t } = useTranslation()
  const companyId = useSelector(contextCompanyIdSelector)!
  const { notification } = App.useApp()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['createFiscalYear'],
    mutationFn: (data: Partial<FiscalYear>) => {
      if (!companyId) {
        throw new Error('Company ID is required for creation')
      }
      return createFiscalYear(data, companyId)
    },
    onSuccess: () => {
      notification.success({
        message: t('messages:createSuccess', 'Request sent')
      })
      return queryClient.invalidateQueries({
        queryKey: fiscalYearQueryKeys.list({ companyId })
      })
    },
    onError: error => {
      notification.error({
        message: t('messages:createError', 'Creation failed'),
        description: error instanceof Error ? error.message : undefined
      })
    }
  })
}
